module.exports = __webpack_public_path__ + "static/media/default_product_img.77c860f4.png";